import { Controller } from "@hotwired/stimulus"

// Shows and hides admin/designs/new's upload fields based on the "Type" select. Initial
// visibility is server-rendered from the record's current type, so this only handles changes.
const FULL_BLEED = "Design::FullBleed";
const HERO_IMAGE = "Design::HeroImage";
const VIDEO = "Design::Video";
const POLAROID = "Design::Polaroid";

export default class extends Controller {
  static get targets() {
    return ["type", "upload", "mobileUpload", "emailUpload", "messageHidden", "video", "legacy"];
  }

  update() {
    const type = this.typeTarget.value;

    this.toggle(this.uploadTarget, !type.includes("Design::Custom"));
    this.toggle(this.mobileUploadTarget, type === FULL_BLEED);
    this.toggle(this.emailUploadTarget, type === FULL_BLEED || type === HERO_IMAGE);
    this.toggle(this.messageHiddenTarget, type === FULL_BLEED || type === HERO_IMAGE);
    this.toggle(this.videoTarget, type === VIDEO || type === FULL_BLEED || type === HERO_IMAGE);
    this.toggle(this.legacyTarget, type === HERO_IMAGE || type === POLAROID);
  }

  toggle(el, show) {
    el.classList.toggle("hidden", !show);
  }
}
